import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import _isEqual from 'lodash/isEqual';
import TextCropper from '@omilia/text-cropper';

import { testSetType } from 'types';

import './style.scss';

/* eslint-disable react/no-find-dom-node */
export default class TestSetItem extends Component {
  static propTypes = {
    selectedTestSet: testSetType.isRequired,
    selectTestSet: PropTypes.func.isRequired,
    testSet: testSetType.isRequired,
  };

  shouldComponentUpdate(nextProps) {
    return (
      !_isEqual(nextProps.testSet, this.props.testSet) ||
      !_isEqual(nextProps.selectedTestSet, this.props.selectedTestSet)
    );
  }

  isActive = () => {
    const { testSet, selectedTestSet } = this.props;

    return testSet.id === selectedTestSet.id;
  };

  handleClick = () => {
    const { testSet, selectTestSet } = this.props;

    selectTestSet(testSet);
  };

  /* eslint-disable jsx-a11y/click-events-have-key-events */
  /* eslint-disable jsx-a11y/no-static-element-interactions */
  render() {
    const { name } = this.props.testSet;

    return (
      <div
        styleName={cn('item', {
          'is-active': this.isActive(),
        })}
        onClick={this.handleClick}
      >
        <div styleName="item__info">
          <span className="icon-test-set" />
          <span styleName="item__name">
            <TextCropper placement="right" styleName="cropper" text={name} />
          </span>
        </div>
      </div>
    );
  }
}
